import { withRouter } from 'react-router-dom';
import Header from '../../../shared/header/header';
import Sidebar from '../../../shared/sidebar/sideBar';
import Taptop from '../../../shared/tap-top/tapTop';
import LandingPageFooter from '../../../shared/landing-page-footer/landing-page-footer';
import styles from './layout.module.scss';

const AccueilLayout: React.FC = ({ children }: any) => {
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  return (
    <>
      <Taptop />
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <Header />
        <div className="page-body-wrapper">
          {window.outerWidth > 992 && <Sidebar />}
          <div className={`${styles['admin-page-body']} page-body`}>{children}</div>
          <LandingPageFooter />
        </div>
      </div>
    </>
  );
};

export default withRouter(AccueilLayout);
